import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';

const AppBundleDetailRouteProcessor = lazyForPaint(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "chunk-app-bundle-detail-page" */ '@atlassian/mpac-app-bundles/bundle-detail-page'
  ).then((c) => ({ default: c.BundleDetailPage }))
);

const RouteHandler = (props) => {
  return (
    <BaseRouteHandler scrollToTopOnPathChange includePartnerQuickLinks>
      <LazySuspense fallback={<div />}>
        <AppBundleDetailRouteProcessor {...props} />
      </LazySuspense>
    </BaseRouteHandler>
  );
};

export default RouteHandler;
